module.exports = __webpack_public_path__ + "static/media/kickstarter.8117548b.svg";